/* eslint-disable security/detect-object-injection */
/* eslint-disable max-len */
/* eslint-disable react/jsx-no-undef */
import { motion } from 'framer-motion'
import React, { useState, useCallback, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Link, useNavigate, useSearchParams } from 'react-router-dom'
import NoOrders from './EmptyPage'
import Shimmer from './Shimmer'
import EmptyPage from './EmptyPage'
import { checkPrivilege } from '../../../CommonMethods/checkPrivilege'

export default function Table({ searchParams,handleSearchParams,loading,DateRange,initialDate, error, notFound }) {
    const { List } = useSelector(state => state.Orders)
    const navigate = useNavigate()
    const param = Object.fromEntries(searchParams);

    const hasViewPrivilege = checkPrivilege('view_order')
    const convertToDate = (timestamp) => {
        const date = new Date(timestamp * 1000); // Convert seconds to milliseconds

        // Format the date in the desired format
        return date.toLocaleDateString('en-US', { year: 'numeric', month: 'short', day: 'numeric' });
    }

    const convertToCrypto = (crypto_amount, crypto_coin) => {
        if(crypto_amount && crypto_coin) {
            return crypto_amount + ' ' + crypto_coin
        }
        return '-'
    }    

    return (
        <div className='bg-white mx-5 overflow-auto h-[calc(100vh-375px)] mt-4 scrollBar'>
            <table className="w-full pr-5 sticky top-0 left-0 bg-white"> {/* ((List?.length !== 0 && loading) || (List?.length?.data !== 0 && !loading)) */}
                { (List?.data?.length > 0 || loading)  &&
                <thead className='sticky top-0 bg-white z-[9]'>
                    <tr className="border-b-[1px] border-[#EEEEEE]">
                        <th className="px-4 py-3 text-left sticky left-0 top-0 min-w-[130px] bg-[#FAFAFA]">
                            <span className="text-base font-normal text-[#4B4B4B] bg-[#FAFAFA]">
                                Order Number
                            </span>
                        </th>
                        <th className='px-4 py-3 text-left min-w-[130px] bg-[#FAFAFA]'>
                            <span className='text-base font-normal text-[#4B4B4B] bg-[#FAFAFA]'>
                                Order Date
                            </span>
                        </th>
                        <th className="px-4 py-3 text-left min-w-[150px] bg-[#FAFAFA]">
                            <span className='text-base font-normal text-[#4B4B4B] bg-[#FAFAFA]'>
                                Cart Number
                            </span>
                        </th>
                        <th className="px-4 py-3 text-left min-w-[150px] bg-[#FAFAFA]">
                            <span className='text-base font-normal text-[#4B4B4B] bg-[#FAFAFA]'>
                                Merchant Name
                            </span>
                        </th>
                        <th className="px-4 py-3 text-left min-w-[150px] bg-[#FAFAFA]">
                            <span className='text-base font-normal text-[#4B4B4B] bg-[#FAFAFA]'>
                                Store Name
                            </span>
                        </th>
                        <th className="px-4 py-3 text-left min-w-[100px] bg-[#FAFAFA]">
                            <span className='text-base font-normal text-[#4B4B4B] bg-[#FAFAFA]'>
                                City
                            </span>
                        </th>
                        <th className="px-4 py-3 text-left min-w-[150px] bg-[#FAFAFA]">
                            <span className='text-base font-normal text-[#4B4B4B] bg-[#FAFAFA]'>
                                Postal Code
                            </span>
                        </th>
                        <th className="px-4 py-3 text-left min-w-[150px] bg-[#FAFAFA]">
                            <span className='text-base font-normal text-[#4B4B4B] bg-[#FAFAFA]'>
                                Customer Email
                            </span>
                        </th>
                        <th className="px-4 py-3 text-right min-w-[175px] bg-[#FAFAFA]">
                            <span className='text-base font-normal text-[#4B4B4B] bg-[#FAFAFA]'>
                                Number of Products
                            </span>
                        </th>
                        <th className="px-4 py-3 text-left min-w-[175px] bg-[#FAFAFA]">
                            <span className='text-base font-normal text-[#4B4B4B] bg-[#FAFAFA]'>
                                Payment Type
                            </span>
                        </th>
                        <th className="px-4 py-3 text-right min-w-[150px] bg-[#FAFAFA]">
                            <span className="text-base font-normal text-[#4B4B4B] bg-[#FAFAFA]">
                                Order Amount
                            </span>
                        </th>
                        <th className="px-4 py-3  text-right min-w-[150px] bg-[#FAFAFA]">
                            <span className="text-base font-normal text-[#4B4B4B] bg-[#FAFAFA]">
                                Commission
                            </span>
                        </th>
                        <th className='px-4 py-3 text-left min-w-[175px] bg-[#FAFAFA]'>
                            <span className='text-base font-normal text-[#4B4B4B] bg-[#FAFAFA]'>
                                Transaction Status
                            </span>
                        </th>
                        <th className='px-4 py-3 text-center bg-[#FAFAFA]'>
                            <span className='text-base font-normal text-[#4B4B4B] bg-[#FAFAFA]'>
                                Action
                            </span>
                        </th>
                    </tr>
                </thead>
                }
                {loading ? <Shimmer column={8}/> :
                    (<tbody>
                        {List?.data?.map((item, index) => (
                            <tr key={index} className="border-b-[1px] border-[#EEEEEE]">
                                <td className="px-4 py-3 whitespace-nowrap break-words sticky left-0 top-0 bg-white min-w-[125px]">
                                    <p data-testid={`order-number-${index}`} class="break-words w-full text-[14px] leading-[22px] font-normal text-[#4B4B4B]">{item?.order_id}</p>
                                </td>
                                <td className="px-4 py-3 whitespace-nowrap break-words">
                                    <p class="break-words w-full text-[14px] leading-[22px] font-normal text-[#4B4B4B]">{convertToDate(item?.created_at)}</p>
                                </td>
                                <td className="px-4 py-3 whitespace-nowrap break-words">
                                    <p class="break-words w-full text-[14px] leading-[22px] font-normal text-[#4B4B4B] max-w-[250px] overflow-hidden text-ellipsis">{item?.cart_number || '-'}</p>
                                </td>
                                <td className="px-4 py-3 whitespace-nowrap break-words">
                                    <p class="break-words w-full text-[14px] leading-[22px] font-normal text-[#4B4B4B] max-w-[250px] overflow-hidden text-ellipsis capitalize">{item?.merchant_name || '-'}</p>
                                </td>
                                <td className="px-4 py-3 whitespace-nowrap break-words">
                                    <p class="break-words w-full text-[14px] leading-[22px] font-normal text-[#4B4B4B] max-w-[250px] overflow-hidden text-ellipsis">{item?.store_name || '-'}</p>
                                </td>
                                <td className="px-4 py-3 whitespace-nowrap break-words">
                                    <p class="break-words w-full text-[14px] leading-[22px] font-normal text-[#4B4B4B] max-w-[250px] overflow-hidden text-ellipsis capitalize">{item?.city || '-'}</p>
                                </td>
                                <td className="px-4 py-3 whitespace-nowrap break-words">
                                    <p class="break-words w-full text-[14px] leading-[22px] font-normal text-[#4B4B4B] max-w-[250px] overflow-hidden text-ellipsis">{item?.postal_code || '-'}</p>
                                </td>
                                <td className="px-4 py-3 whitespace-nowrap break-words">
                                    <p class="break-words w-full text-[14px] leading-[22px] font-normal text-[#4B4B4B] max-w-[250px] overflow-hidden text-ellipsis">{item?.customer_email_address || '-'}</p>
                                </td>
                                <td className="px-4 py-3 whitespace-nowrap break-words text-right pr-6">
                                    <p class="break-words w-full text-[14px] leading-[22px] font-normal text-[#4B4B4B]">{item?.quantity || '-'}</p>
                                </td>
                                <td className="px-4 py-3 whitespace-nowrap break-words">
                                    <p class="break-words w-full text-[14px] leading-[22px] font-normal text-[#4B4B4B]">{item?.payment_method || item?.payment_type || '-'}</p>
                                </td>
                                <td className="px-4 py-3 whitespace-nowrap break-words text-right">
                                    <p class="break-words w-full text-[14px] leading-[22px] font-normal text-[#4B4B4B] text-right">{`${item?.currency?.symbol || `$`}${item?.order_amount.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`}</p>
                                </td>
                                <td className="px-4 py-3 whitespace-nowrap break-words text-right">
                                    <p class="break-words w-full text-[14px] leading-[22px] font-normal text-[#4B4B4B] text-right">{`${item?.currency?.symbol || `$`}${item?.commission ? item?.commission : '0'}`}</p>
                                </td>
                                <td className="px-4 py-3 whitespace-nowrap break-words flex gap-[9px] cursor-default">
                                    <img className='cursor-default' src={`/assets/images/${item?.payment_status}.svg`} />
                                    <p data-testid="order-status" class="break-words w-full text-[14px] leading-[22px] font-normal text-[#4B4B4B] text-left">{item?.payment_status}</p>
                                </td>
                                <td data-testid={`order-view-${index}`} className={`px-4 py-3 whitespace-nowrap break-words text-center ${hasViewPrivilege ? 'cursor-pointer' : 'cursor-not-allowed'}`}
                                    onClick={() => {
                                        if (hasViewPrivilege) {
                                            navigate(`/orders-purchases/${item._id}`)
                                        }
                                    }
                                    }>
                                    <p class="break-words w-full text-[14px] leading-[22px] font-normal text-[#4B4B4B] text-center">View</p>
                                </td>
                            </tr>
                        ))
                        }
                    </tbody>)}
            </table>
            {notFound && <div className='w-full flex justify-center'><EmptyPage text = "404 could not find what you are looking for."/></div>}
            {!notFound && error && (<div className='w-full flex justify-center'><EmptyPage text='No orders available yet' /></div>)}
            {List?.data?.length === 0 && !loading && !(param.search || param.status || param.payment_type || param.create_start || param.create_end || param.store_email_address) && (<div className='w-full flex justify-center'><EmptyPage text='No orders available yet' /></div>)}
            {List?.data?.length === 0 && !loading && (param.status || param.payment_type || param.create_start || param.create_end || param.store_email_address) && (<div className='w-full flex justify-center'><EmptyPage text='The filter combination has no results.' subtext='Please try different criteria.' /></div>)}
            {List?.data?.length === 0 && !loading && param.search && (<div className='w-full flex justify-center'><EmptyPage text = "We couldn't find what you searched for." subtext="Please try a different search or try again" /></div>)}
        </div>
    )
}
